import {IPaymentTransaction} from "@connox/typescript-library/types/checkout/requestHandlers/CheckoutRequestHandler";
import window from "../components/lib/WindowExtended";
import {PaymentController} from "../components/lib/payments/PaymentController";
import {Checkout} from "@connox/typescript-library";
import {FUNDING_SOURCE} from "@paypal/paypal-js";

export type OnApproveInfoType = {
  lastPaymentTransaction: IPaymentTransaction | null;
  lastWorkingCall: string | null;
};

export const purchase = async (checkout: Checkout, nonce: string, prefix: string, paymentSource?: FUNDING_SOURCE) => {
  const info: OnApproveInfoType = {
    lastPaymentTransaction: null,
    lastWorkingCall: null,
  };
  try {
    if (window.annotationTextArea !== (checkout.customerRemark ?? undefined)) {
      await checkout.put({customerRemark: window.annotationTextArea});
      info.lastPaymentTransaction = checkout.paymentTransaction;
      info.lastWorkingCall = `${prefix}CustomerRemarkPut`;
    }
    info.lastPaymentTransaction = await PaymentController.initPayment();
    info.lastWorkingCall = `${prefix}InitPayment`;
    info.lastPaymentTransaction = await PaymentController.authorizePayment(nonce);
    info.lastWorkingCall = `${prefix}AuttPayment`;
    await checkout.purchase();
  } catch (err) {
    (err as Error).name = "Purchase" + (err as Error).name;
    (err as Error & {info: OnApproveInfoType}).info = info;
    (err as Error & {paymentSource: FUNDING_SOURCE | undefined}).paymentSource = paymentSource;
    throw err;
  }
};
